import { Suspense } from 'react';
import {
  Redirect,
  Route,
  Router as ReactRouter,
  Switch,
} from 'react-router-dom';
import { history } from 'shared/history';
import { SuspenseFallback } from 'shared/suspenseFallback';
import { Paths, routes } from './routes';

export const Router = () => {
  return (
    <ReactRouter history={history}>
      <Suspense fallback={<SuspenseFallback />}>
        <Switch>
          {routes.map((el) => {
            return (
              <Route
                key={el.path}
                exact={el.exact}
                path={el.path}
                component={el.component}
              />
            );
          })}
          <Redirect to={Paths.SelectGroup} />
        </Switch>
      </Suspense>
    </ReactRouter>
  );
};
